import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { R300 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { FormattedI18nMessage } from '@atlassian/jira-formatted-i18n-message/src/ui/index.tsx';
import LockClosedImage from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/objects/components/lock-closed';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages';

const Bold = ({ children }: { children: ReactNode }) => <b>{children}</b>;

export const NoDataEnableOutgoingMailInfo = () => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const siteUrl = window.location.hostname;
	const { formatMessage } = useIntl();
	return (
		<OutgoingMailErrorContainer>
			<OutgoingMailInfoWrapper>
				<LockClosedImage height="222" width="191" alt="no failure logs" />
				<OutgoingMailErrorText>
					<ErrorIcon size="medium" label="" primaryColor={token('color.icon.danger', R300)} />
					<FormattedI18nMessage
						message={formatMessage(messages.configDisabledAndNoFailureLogs, {
							boldStart: '{boldStart}',
							boldEnd: '{boldEnd}',
							siteUrl,
						})}
						componentsMapping={{ bold: Bold }}
					/>
				</OutgoingMailErrorText>
			</OutgoingMailInfoWrapper>
		</OutgoingMailErrorContainer>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const OutgoingMailErrorContainer = styled.div({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	height: '500px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const OutgoingMailInfoWrapper = styled.div({
	margin: token('space.150', '12px'),
	marginLeft: 0,
	textAlign: 'center',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	flexDirection: 'column',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const OutgoingMailErrorText = styled.div({
	padding: token('space.150', '12px'),
	paddingLeft: 0,
	display: 'inline-block',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	span: {
		position: 'relative',
		top: token('space.075', '6px'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	a: { bottom: token('space.075', '6px') },
});
